import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchRecipesData = createAsyncThunk("recipes/fetchRecipesData", async ({ lang = "en" }) => {
  const response = await axios.post(
    "https://milkys.bytesway.io/api/recipes-page",
    {
      lang,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data?.data || {};
});

const recipesSlice = createSlice({
  name: "recipes",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecipesData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRecipesData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchRecipesData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default recipesSlice.reducer;
